const wishlistKey = 'tvara-wishlist';
let inMemoryItems;

const getItems = () => {
  if (inMemoryItems) return inMemoryItems;

  try {
    const items = JSON.parse(window.localStorage.getItem(wishlistKey));
    inMemoryItems = Array.isArray(items) ? items.filter((item) => item?.id && item?.url && item?.title) : [];
  } catch {
    inMemoryItems = [];
  }

  return inMemoryItems;
};

const saveItems = (items) => {
  inMemoryItems = items;

  try {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  } catch {
    // Keep the current-page state usable when storage is unavailable.
  }
};

const updateButton = (button, saved) => {
  button.dataset.wishlistAdded = String(saved);
  button.setAttribute('aria-pressed', String(saved));
  button.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} ${button.dataset.wishlistProductTitle} ${saved ? 'from' : 'to'} wishlist`);
  button.querySelector('.visually-hidden').textContent = saved ? 'Remove from wishlist' : 'Add to wishlist';
};

const renderWishlist = () => {
  const items = getItems();
  const savedIds = new Set(items.map((item) => String(item.id)));

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    updateButton(button, savedIds.has(button.dataset.wishlistProductId));
  });

  document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
    count.textContent = items.length;
    count.hidden = items.length === 0;
  });

};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');
  const remove = event.target.closest('[data-wishlist-remove]');

  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const item = {
      id: toggle.dataset.wishlistProductId,
      title: toggle.dataset.wishlistProductTitle,
      url: toggle.dataset.wishlistProductUrl,
    };
    const items = getItems();
    const saved = items.some((savedItem) => String(savedItem.id) === String(item.id));
    saveItems(saved ? items.filter((savedItem) => String(savedItem.id) !== String(item.id)) : [...items, item]);
    renderWishlist();
    window.dispatchEvent(new CustomEvent('tvara:wishlist-change', { detail: { items: getItems() } }));
  }

  if (remove) {
    event.preventDefault();
    const items = getItems().filter((item) => String(item.id) !== String(remove.dataset.wishlistRemove));
    saveItems(items);
    renderWishlist();
    window.dispatchEvent(new CustomEvent('tvara:wishlist-change', { detail: { items } }));
  }
});

window.addEventListener('storage', (event) => {
  if (event.key === wishlistKey) {
    inMemoryItems = undefined;
    renderWishlist();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderWishlist, { once: true });
} else {
  renderWishlist();
}
